// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fcdce786","665":"4f2de13f"}[chunkId] + ".chunk.js";
};